// extracted by mini-css-extract-plugin
export default {"root":"styles_root__9mpHN","actionsWrap":"styles_actionsWrap__BjG0J","actionBtn":"styles_actionBtn__2m5wv","minusBtn":"styles_minusBtn__pjYP4"};